module.exports = "<div class=\"wechat_msg\">\r\n  <img src=\"/public/images/bg.jpg\"/>\r\n  <div class=\"wechat_content\">{{message}}</div>\r\n  <div>\r\n    <button data-bind=\"click: goLogin\">返回登录</button>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/wechatMsg/WechatMsg.html
// module id = 178
// module chunks = 0